import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgChartsModule } from 'ng2-charts';

import { CommonService } from '../../services/common.service';
import { CompanyComponent } from './component/company.component';
import { CompanyDashboardComponent } from './component/dashboard/company-dashboard.component';
import { StyleComponent } from './component/style/style.component';
import { StyleInfoComponent } from './component/style-info/style-info.component';
import { CompanyOrderInfoComponent } from './component/order-info/company-order-info.component';
import { CompanyOrderListComponent } from './component/order-list/company-order-list.component';
import { PhotographersComponent } from './component/photographers/photographers.component';
import { PhotographerEditComponent } from './component/photographer-edit/photographer-edit.component';
import { SidebarRejectComponent } from './component/sidebar-reject/sidebar-reject.component';
import { TemplatesComponent } from './component/templates/templates.component';
import { SharedModule } from '../../shared/shared.module';
import { CompanyRouting } from './company.routing';
import { PhotographerOrdersComponent } from './component/photographer-orders/photographer-orders.component';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { UiAvatarImageComponent } from '../../shared/libs/up-header/ui-avatar/ui-avatar-image.component';
import { UpTopHeaderComponent } from '../../shared/libs/up-header/up-top-header/up-top-header.component';
import { MatTabsModule } from '@angular/material/tabs';
import { HasRoleDirective } from '../../services/directives/has-role.directive';
import { TemplateFormComponent } from './component/templates/template-form/template-form.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { A11yModule } from '@angular/cdk/a11y';
import { OrderDetailInfoComponent } from './component/order-info/order-detail-info/order-detail-info.component';
import { OrderDetailShotsComponent } from './component/order-info/order-detail-shots/order-detail-shots.component';
import { ApproveOrderNoteComponent } from './component/order-info/approve-order-note/approve-order-note';
import { NewCompanyOrderComponent } from './component/new-order/new-company-order-info.component';
import { NewOrderDetailInfoComponent } from './component/new-order/new-order-detail-info/new-order-detail-info.component';
import { NewOrderDetailShotsComponent } from './component/new-order/new-order-detail-shots/new-order-detail-shots.component';
import { AddProductModalComponent } from './component/new-order/add-product-modal/add-product-modal.component';
import { UnifiedOrderViewComponent } from './component/unified-order/unified-order-view.component';
import { UnifiedOrderDetailInfoComponent } from './component/unified-order/unified-order-detail-info/unified-order-detail-info.component';
import { UnifiedOrderDetailShotsComponent } from './component/unified-order/unified-order-detail-shots/unified-order-detail-shots.component';
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		NgChartsModule,
		SharedModule,
		CompanyRouting,
		A11yModule,
		UiAvatarImageComponent,
		UpTopHeaderComponent,
		// Material Import:
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		MatButtonModule,
		MatDialogModule,
		MatChipsModule,
		MatIconModule,
		MatTabsModule,
		HasRoleDirective,
		MatSlideToggleModule,
		MatAutocompleteModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatCheckboxModule,
		MatExpansionModule
	],
	declarations: [
		CompanyComponent,
		CompanyDashboardComponent,
		CompanyOrderListComponent,
		StyleComponent,
		PhotographersComponent,
		TemplatesComponent,
		StyleInfoComponent,
		CompanyOrderInfoComponent,
		PhotographerEditComponent,
		SidebarRejectComponent,
		PhotographerOrdersComponent,
		TemplateFormComponent,
		OrderDetailInfoComponent,
		OrderDetailShotsComponent,
		NewCompanyOrderComponent,
		NewOrderDetailInfoComponent,
		NewOrderDetailShotsComponent,
		ApproveOrderNoteComponent,
		AddProductModalComponent,
		UnifiedOrderViewComponent,
		UnifiedOrderDetailInfoComponent,
		UnifiedOrderDetailShotsComponent,
	],
	exports: [CompanyComponent],
	providers: [CommonService]
})
export class CompanyModule { }
